import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import styled, { css } from 'styled-components';
import type { SortOption } from '../../CollapsedSelect';
import { TEST_ID_SORT_OPTION } from '../../constants';

const CustomOption = (props: OptionProps<SortOption>) => {
  const { children, ...other } = props;

  const {
    data: { id, order, selected },
  } = other;

  return (
    <components.Option {...other}>
      <BodyOption
        selected={selected}
        data-testid={`${TEST_ID_SORT_OPTION}_${id}_${order}`}
      >
        {children}
      </BodyOption>
    </components.Option>
  );
};

const BodyOption = styled.div<{ selected: boolean }>`
  padding: 16px 8px;
  cursor: pointer;

  border-bottom: 1px solid #e6e9ee;

  ${(props) =>
    !props.selected &&
    css`
      &:hover {
        background-color: #e6e9ee;
        color: black;
      }
    `}

  &:active {
    background-color: #007aff;
    color: white;
  }

  ${(props) =>
    props.selected &&
    css`
      pointer-events: none;
      background-color: #007aff;
      color: white;
    `}
`;

export default CustomOption;
